import React from 'react';
import { observer } from 'mobx-react';
import { Box } from '@mui/material';
import InboxTreeItemRenderer from '../InboxTreeItemRenderer';
import { InboxTreeProps } from './types';
import ViewSkeleton from '10.quickConnect.app/components/domain/Home/Shared/Skeletons/viewSkeleton';
import CustomTree from '10.quickConnect.app/components/domain/Home/Shared/CustomTree';
import { getTreeBoxStyle } from '10.quickConnect.app/components/domain/Home/styles';
import { InboxViewer } from '90.quickConnect.Models/models';

const InboxTree = ({ store, title, treeName, cle }: InboxTreeProps) => {
  return (
    <Box
      data-cy={treeName}
      sx={{ ...getTreeBoxStyle(), height: { xs: 'unset', sm: 'unset', md: 'inherit', lg: 'inherit' } }}
    >
      {store.items ? (
        <CustomTree<InboxViewer>
          title={title}
          store={store}
          RenderTreeItem={InboxTreeItemRenderer}
          getName={(i: InboxViewer) => i.subject}
          cle={cle}
        />
      ) : (
        <ViewSkeleton />
      )}
    </Box>
  );
};

export default observer(InboxTree);
